import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/app/base/base.component';
import { SnackService } from 'src/app/services/snack.service';
import { combineForLoading, combineLogicalOr } from 'src/app/shared/utils';
import { AppUser } from 'src/app/shared/models/app-user';
import { DashboardDto, ListUserDashboardDto, UserDto } from '../../../services/api.services';
import { AppActions, AppSelectors } from '../../../state/app';
import { WelcomeActions, WelcomeSelectors } from '../../state/welcome';
import { WelcomeDashboard } from '../../state/welcome/reducer';

@Component({
  selector: 'app-welcome-shell-component',
  template: `
    <app-welcome-component
      [busy]="busy$ | async"
      [loading]="loading$ | async"
      [saving]="saving$ | async"

      [user]="user$ | async"

      [loadingDashboards]="loadingDashboards$ | async"
      [dashboards]="dashboards$ | async"

      [selectedDashboardId]="selectedDashboardId$ | async"
      (selectDashboard)="selectDashboard($event)"

      (addToHome)="addToHome($event)"
    ></app-welcome-component>`,
  standalone: false
})
export class WelcomeShellComponent extends BaseComponent implements OnInit, OnDestroy {
  static readonly dialogConfig = <MatDialogConfig>{
    panelClass: 'welcome-dialog-panel',
    hasBackdrop: true,
    disableClose: true,

    width: '100%',
    maxWidth: '1415px',
    height: '800px',
    maxHeight: '95vh',
  };

  busy$: Observable<boolean>;
  loading$: Observable<boolean>;
  saving$: Observable<boolean>;

  user$: Observable<AppUser>;

  savingUserState$: Observable<boolean>;

  loadingDashboards$: Observable<boolean>;
  dashboards$: Observable<ListUserDashboardDto[]>;

  selectedDashboardId$: Observable<number>;

  constructor(
    public store: Store,
    public router: Router,
    public route: ActivatedRoute,
    public snackService: SnackService) {
    super(store, router, route, snackService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.savingUserState$ = this.store.select(AppSelectors.isSavingUserState);

    this.loadingDashboards$ = this.store.select(WelcomeSelectors.loadingDashboards);
    this.dashboards$ = this.store.select(WelcomeSelectors.displayedDashboards);

    this.selectedDashboardId$ = this.store.select(WelcomeSelectors.selectedDashboardId);

    this.user$ = this.store.select(AppSelectors.getUser);

    this.loading$ = combineForLoading(
      this.loadingDashboards$
    );

    this.saving$ = combineLogicalOr(
      this.savingUserState$,
    );

    this.busy$ = combineLogicalOr(
      this.loading$,
      this.saving$
    );

    this.store.dispatch(WelcomeActions.loadDashboards());
  }

  selectDashboard(dashboard: WelcomeDashboard) {
    this.store.dispatch(WelcomeActions.setSelectedDashboard({ dashboardId: dashboard.id }));
  }

  addToHome(dashboard: WelcomeDashboard) {
    if (!dashboard) {
      // Admin only - close the dialog when no dashboards available
      this.store.dispatch(WelcomeActions.adminHideDialog());
    }
    else {
      this.store.dispatch(WelcomeActions.addDashboardToHome({ dashboardId: dashboard.id }));
    }
  }
}
